import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

// Fonction pour générer un vrai PDF à partir du HTML
export const generateRealPDF = async (cvData, cvStyle, template) => {
    // Créer un élément temporaire pour le rendu
    const tempDiv = document.createElement('div');
    tempDiv.style.position = 'absolute';
    tempDiv.style.left = '-9999px';
    tempDiv.style.top = '0';
    tempDiv.style.width = '800px';
    tempDiv.style.backgroundColor = 'white';
    tempDiv.style.padding = '20px';
    tempDiv.style.fontFamily = 'Arial, sans-serif';
    tempDiv.style.fontSize = '12px';
    tempDiv.style.lineHeight = '1.4';
    
    // Générer le contenu HTML
    const htmlContent = generateCVContent(cvData, cvStyle, template);
    tempDiv.innerHTML = htmlContent;
    
    // Ajouter au DOM temporairement
    document.body.appendChild(tempDiv);
    
    try {
        // Convertir en canvas puis en PDF
        const canvas = await html2canvas(tempDiv, {
            scale: 2,
            useCORS: true,
            backgroundColor: '#ffffff'
        });
        
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
        
        const imgWidth = 210; // A4 width in mm
        const pageHeight = 295; // A4 height in mm
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;
        
        let position = 0;
        
        // Ajouter l'image au PDF
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
        
        // Ajouter des pages supplémentaires si nécessaire
        while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            pdf.addPage();
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
        }
        
        return pdf;
    } finally {
        // Nettoyer l'élément temporaire
        document.body.removeChild(tempDiv);
    }
};

// Fonction pour générer le contenu HTML du CV
const generateCVContent = (cvData, cvStyle, template) => {
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString + '-01');
        return date.toLocaleDateString('fr-FR', { month: 'short', year: 'numeric' });
    };

    return `
        <div style="max-width: 800px; margin: 0 auto; background: white; padding: 20px; font-family: Arial, sans-serif;">
            <div style="text-align: center; margin-bottom: 30px; padding-bottom: 20px; border-bottom: 2px solid #e5e7eb;">
                <h1 style="font-size: 24px; font-weight: bold; color: #1f2937; margin: 0 0 10px 0;">
                    ${cvData.personalInfo.firstName} ${cvData.personalInfo.lastName}
                </h1>
                <p style="font-size: 14px; color: #6b7280; margin: 0;">
                    ${cvData.personalInfo.email}
                </p>
            </div>
            
            ${cvData.summary ? `
            <div style="margin-bottom: 25px;">
                <h2 style="font-size: 16px; font-weight: bold; color: #1f2937; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px solid #e5e7eb;">
                    Résumé professionnel
                </h2>
                <p style="font-size: 13px; line-height: 1.5; color: #4b5563;">
                    ${cvData.summary}
                </p>
            </div>
            ` : ''}
            
            ${cvData.experience && cvData.experience.length > 0 ? `
            <div style="margin-bottom: 25px;">
                <h2 style="font-size: 16px; font-weight: bold; color: #1f2937; margin-bottom: 15px; padding-bottom: 5px; border-bottom: 1px solid #e5e7eb;">
                    Expérience professionnelle
                </h2>
                ${cvData.experience.map(exp => `
                    <div style="margin-bottom: 15px;">
                        <div style="font-size: 14px; font-weight: bold; color: #1f2937;">
                            ${exp.title || 'Poste'}
                        </div>
                        <div style="font-size: 12px; color: #6b7280; margin-bottom: 3px;">
                            ${exp.company || 'Entreprise'}
                        </div>
                        <div style="font-size: 11px; color: #9ca3af;">
                            ${exp.startDate ? formatDate(exp.startDate) : ''} - ${exp.endDate ? formatDate(exp.endDate) : 'Présent'}
                        </div>
                    </div>
                `).join('')}
            </div>
            ` : ''}
            
            ${cvData.education && cvData.education.length > 0 ? `
            <div style="margin-bottom: 25px;">
                <h2 style="font-size: 16px; font-weight: bold; color: #1f2937; margin-bottom: 15px; padding-bottom: 5px; border-bottom: 1px solid #e5e7eb;">
                    Formation
                </h2>
                ${cvData.education.map(edu => `
                    <div style="margin-bottom: 15px;">
                        <div style="font-size: 14px; font-weight: bold; color: #1f2937;">
                            ${edu.degree || 'Diplôme'}
                        </div>
                        <div style="font-size: 12px; color: #6b7280; margin-bottom: 3px;">
                            ${edu.institution || 'Établissement'}
                        </div>
                        <div style="font-size: 11px; color: #9ca3af;">
                            ${edu.startDate ? formatDate(edu.startDate) : ''} - ${edu.endDate ? formatDate(edu.endDate) : 'Présent'}
                        </div>
                    </div>
                `).join('')}
            </div>
            ` : ''}
            
            ${cvData.skills && cvData.skills.length > 0 ? `
            <div style="margin-bottom: 25px;">
                <h2 style="font-size: 16px; font-weight: bold; color: #1f2937; margin-bottom: 15px; padding-bottom: 5px; border-bottom: 1px solid #e5e7eb;">
                    Compétences
                </h2>
                <div style="display: flex; flex-wrap: wrap; gap: 6px;">
                    ${cvData.skills.map(skill => {
                        console.log('🔍 Compétence dans generateCVContent:', skill, 'Type:', typeof skill);
                        let skillName = '';
                        if (typeof skill === 'string') {
                            skillName = skill;
                        } else if (typeof skill === 'object' && skill !== null) {
                            console.log('🔍 Propriétés de l\'objet compétence:', Object.keys(skill));
                            skillName = skill.name || skill.title || skill.skill || skill.value || Object.values(skill).join(' ') || '[Compétence]';
                        } else {
                            skillName = String(skill);
                        }
                        skillName = skillName.replace(/[{}"]/g, '').trim();
                        console.log('🔍 Nom de compétence final:', skillName);
                        return `<span style="background: #f3f4f6; padding: 3px 6px; border-radius: 3px; font-size: 11px; color: #374151;">${skillName}</span>`;
                    }).join('')}
                </div>
            </div>
            ` : ''}
            
            ${cvData.projects && cvData.projects.length > 0 ? `
            <div style="margin-bottom: 25px;">
                <h2 style="font-size: 16px; font-weight: bold; color: #1f2937; margin-bottom: 15px; padding-bottom: 5px; border-bottom: 1px solid #e5e7eb;">
                    Projets
                </h2>
                <div style="display: flex; flex-wrap: wrap; gap: 6px;">
                    ${cvData.projects.map(project => {
                        console.log('🔍 Projet dans generateCVContent:', project, 'Type:', typeof project);
                        let projectName = '';
                        if (typeof project === 'string') {
                            projectName = project;
                        } else if (typeof project === 'object' && project !== null) {
                            console.log('🔍 Propriétés de l\'objet projet:', Object.keys(project));
                            projectName = project.name || project.title || project.project || project.value || Object.values(project).join(' ') || '[Projet]';
                        } else {
                            projectName = String(project);
                        }
                        projectName = projectName.replace(/[{}"]/g, '').trim();
                        console.log('🔍 Nom de projet final:', projectName);
                        return `<span style="background: #f3f4f6; padding: 3px 6px; border-radius: 3px; font-size: 11px; color: #374151;">${projectName}</span>`;
                    }).join('')}
                </div>
            </div>
            ` : ''}
        </div>
    `;
};
